import { useQuery, useMutation, useQueryClient } from 'react-query';
import { fetchCharges, addCharge, updateCharge, deleteCharge } from '@/features/charge/services/chargeService';
const useCharges = (page = 1, filters = {}, all = false, limit = 10) => {
    const queryClient = useQueryClient();
    // Fetch charges (supports pagination, filtering, and the "all" flag)
    const { data, error, isLoading, refetch, } = useQuery(['charges', { page, filters, all, limit }], () => fetchCharges(page, filters, all, limit), {
        keepPreviousData: true,
        staleTime: 60000,
    });
    // Mutation for adding a charge.
    const addChargeMutation = useMutation((charge) => addCharge(charge), {
        onSuccess: () => {
            queryClient.invalidateQueries(['charges']);
        },
    });
    // Mutation for updating a charge.
    const updateChargeMutation = useMutation((charge) => updateCharge(charge), {
        onSuccess: () => {
            queryClient.invalidateQueries(['charges']);
        },
    });
    // Mutation for deleting a charge.
    const deleteChargeMutation = useMutation((id) => deleteCharge(id), {
        onSuccess: () => {
            queryClient.invalidateQueries(['charges']);
        },
    });
    return {
        charges: data?.charges || [],
        chargeMetaData: data?.meta || null,
        chargesLoading: isLoading,
        chargeError: error ? error.message : null,
        handleAddCharge: addChargeMutation.mutateAsync,
        handleUpdateCharge: updateChargeMutation.mutateAsync,
        handleDeleteCharge: deleteChargeMutation.mutateAsync,
        refetchCharges: refetch,
    };
};
export default useCharges;
